import { __makeTemplateObject, __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import styled from '@emotion/styled';
import { forwardRef } from 'react';
import { keyframes } from '@emotion/react';
import { gray } from '@clover-css/colors';
import { useTranslation } from 'react-i18next';

var keyWrapper = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n100% {\n  transform: translateX(100%);\n}\n"], ["\n100% {\n  transform: translateX(100%);\n}\n"])));
/**
 * @title
 *  Shimmer Story
 * @label
 *  Shimmer Story
 * @shortdescription
 *  Shimmer Story  Component
 * @keywords
 *  [Shimmer Story ,Shimmer Story  Component]
 * @description
 * Creates a Shimmer Story
 * @componentUsage
 *    <Shimmer lines={[
        { spacing: 15, leftWidth: 10, rightWidth: 0, height: 20 },
        { spacing: 15, leftWidth: 15, rightWidth: 0, height: 20 },
        { spacing: 35, leftWidth: 30, rightWidth: 0, height: 20 },
        { spacing: 25, leftWidth: 17, rightWidth: 25, height: 10 },
        { spacing: 25, leftWidth: 27, rightWidth: 15, height: 10 },
        { spacing: 25, leftWidth: 32, rightWidth: 17, height: 10 },
        { spacing: 25, leftWidth: 37, rightWidth: 19, height: 10 },
        { spacing: 25, leftWidth: 42, rightWidth: 22, height: 10 },
        { spacing: 25, leftWidth: 47, rightWidth: 25, height: 10 },
      ]} />
 * @example
 *    <Shimmer lines={[
        { spacing: 15, leftWidth: 10, rightWidth: 0, height: 20 },
        { spacing: 15, leftWidth: 15, rightWidth: 0, height: 20 },
        { spacing: 35, leftWidth: 30, rightWidth: 0, height: 20 },
        { spacing: 25, leftWidth: 17, rightWidth: 25, height: 10 },
        { spacing: 25, leftWidth: 27, rightWidth: 15, height: 10 },
        { spacing: 25, leftWidth: 32, rightWidth: 17, height: 10 },
        { spacing: 25, leftWidth: 37, rightWidth: 19, height: 10 },
        { spacing: 25, leftWidth: 42, rightWidth: 22, height: 10 },
        { spacing: 25, leftWidth: 47, rightWidth: 25, height: 10 },
      ]} />
 *
 */
var ShimmerLine = styled.span(function (props) {
    var _a;
    return ({
        backgroundColor: "".concat(gray.light.rgb),
        width: "".concat(props.width || props.width === 0 ? props.width : 100, "%"),
        borderRadius: '4px',
        display: 'inline-flex',
        height: "".concat(props.height || 15, "px"),
        position: 'relative',
        overflow: 'hidden',
        zIndex: 1,
        marginTop: "".concat(props.spacing || 0, "px"),
        '&:after': {
            content: '" "',
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '100%',
            backgroundRepeat: 'no-repeat',
            transform: 'translateX(-100%)',
            animationName: keyWrapper,
            animationDirection: 'normal',
            animationDuration: '1.25s',
            animationTimingFunction: 'ease-in-out',
            animationIterationCount: 'infinite',
            backgroundImage: 'linear-gradient(90deg, #eff1f3, #e2e2e2, #eff1f3)',
            animationDelay: "".concat((_a = props.animationDelay) !== null && _a !== void 0 ? _a : 0, "s"),
        },
    });
});
var ShimmerContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var DEFAULT_NUM_LINES = 5;
var DefaultShimmerLineProps = { spacing: 24, leftWidth: 100, rightWidth: 0, height: 24 };
var defaultValues = Array(DEFAULT_NUM_LINES).fill(DEFAULT_NUM_LINES).map(function () { return DefaultShimmerLineProps; });
var Shimmer = forwardRef(function (_a, ref) {
    var _b = _a.lines, lines = _b === void 0 ? defaultValues : _b, props = __rest(_a, ["lines"]);
    var t = useTranslation('reportingLib').t;
    return (jsx("div", __assign({ ref: ref }, props, { children: lines.map(function (_a, index) {
            var leftWidth = _a.leftWidth, rightWidth = _a.rightWidth, height = _a.height, spacing = _a.spacing;
            return (jsxs(ShimmerContainer, __assign({ "aria-label": t('shimmer.loading') }, { children: [jsx(ShimmerLine, { "aria-hidden": true, height: height, spacing: spacing, width: leftWidth }), jsx(ShimmerLine, { "aria-hidden": true, height: height, spacing: spacing, width: rightWidth, animationDelay: 0.5 })] }), index));
        }) })));
});
Shimmer.displayName = 'Shimmer';
var templateObject_1, templateObject_2;

export { Shimmer, ShimmerContainer, ShimmerLine };
